import axios from "axios";
import Token from "../../utilities/jwt/Token.js";

export default class AuthService extends Token {

  constructor(endpoint) {
    super();
    this.endpoint = endpoint;
  }
  login() {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: this._api_url + "auth-rest/api/auth/login",
        data:
        {
          "login": process.env.VUE_APP_USER,
          "senha": process.env.VUE_APP_PASSWORD
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          new Token().storeToken(response.data);
          resolve();
        })
        .catch((response) => {
          reject(response);
        });
    });
  }
}